import React from 'react';
import { SelectLabel, Section, InputLabel, Input, Message, Icon } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '../../../attendee/detail/components/utils';
import css from './imports-steps.module.css';

export const DistributorsForm = ({ displayErrorMessage, disabledSelect, defaultOrigin, distributors, loadingDistributors, form, setForm }) => {
    const { t } = useTranslation();

    const originOptions = React.useMemo(() => {
        if (!distributors?.length || loadingDistributors) {
            return [];
        }
        let options = [
            {
                text: (
                    <span className={css['icon_select_option']}>
                        <Icon name="plus" />
                        {t('ticket.attendees.imports.steps.file.manual-origin.option')}
                    </span>
                ),
                value: 'newOrigin',
                key: 'newOrigin'
            }
        ];
        distributors
            ?.filter(dst => dst.id === defaultOrigin || dst.organization) // Filter only default and custom distributors
            .map(dst => {
                return options.push({
                    text: capitalizeFirstLetter(dst.label),
                    value: dst.id,
                    key: dst.id
                });
            });
        return options;
    }, [distributors, loadingDistributors, defaultOrigin]);

    return (
        <div>
            {displayErrorMessage && (
                <Message type="danger" title={t('ticket.attendees.imports.steps.file.error_seated_session_event_title')}>
                    {t('ticket.attendees.imports.steps.file.error_seated_session_event_message')}
                </Message>
            )}

            <SelectLabel
                useNew
                label={t('ticket.common.origin')}
                options={originOptions}
                onChange={value => setForm('origin', value)}
                placeholder={t('ticket.manual_import.title')}
                value={form.origin}
                disabled={disabledSelect}
                onClear={() => setForm('origin', null)}
            />
            {form.origin === 'newOrigin' && (
                <Section>
                    <InputLabel label={t('ticket.attendees.imports.steps.file.manual-origin.label')} />
                    <Input
                        disabled={disabledSelect}
                        value={form.newOrigin}
                        placeholder={t('ticket.attendees.imports.steps.file.manual-origin.placeholder')}
                        onChange={({ target: { value } }) => setForm('newOrigin', value)}
                    />
                </Section>
            )}
        </div>
    );
};
